import { useLazyQuery, useMutation } from "@apollo/client";
import { memo, useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { replaceUnderscore } from "../../../../CommonFunction/common";
import useSubmitOperation, {
  getMutationFunction,
  handleFormSubmission,
  usePrepareGraphQLVariables,
} from "../../../../CommonFunction/CustomUseFormSubmission";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import useFetchFormFields from "../../../custom_hooks/useFetchFormFields";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import { handleFormReset, updateSingleField, updateValueForm } from "../../FormInputSectionComponent/formUtils";
import { useModalContext } from "../../Reactportal/ModalContext";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import { ErrorToast, SuccessToast } from "../../ToastComponent/RectHotToast";
import "./AddClaims.scss";
import { accecpt_Claim, edit_Claims, getClaimById, reject_Claim } from "../../../../Utils/AllPagesQuriesAndMutations";
import Button from "../../Button/Button";
import { RiErrorWarningFill } from "react-icons/ri";
import useIsDisabled from "../../../custom_hooks/useIsDisabled";

const AddClaimsComponent = ({ show, TypeOfPortal, submitType, ParentPortalCloseFunction }) => {
  const formRef = useRef({});
  const { pushModal, popModal } = useModalContext();
  const [isFirstLoad, setFirstLoad] = useState(false);
  const Form_Key = "Claims";
  const fielddataRedux = useSelector((store) => store.UniqueTableReducer);
  const fielddata = fielddataRedux[Form_Key]?.Selected_Row;
  const [toggle, settoggle] = useState(show ? show : false);
  const [allFieldsData, setAllFieldsData] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [FormData, setFormdata] = useState({});
  const dispatch = useDispatch();
  const [initialData,setInitialData]=useState({})
  const {isDisabled}=useIsDisabled({TypeOfPortal,initial:initialData, current:FormData});


  const [openAcceptModal, setOpenAcceptModal] = useState({
    status: false,
    id: null,
    message: "",
  });
  const [openRejectModal, setOpenRejectModal] = useState({
    status: false,
    id: null,
    message: "",
  });

  // Q & M
  const {
    loading: getFormFieldsLoading,
    data: inputFields,
    getFormSectionAndFields,
  } = useFetchFormFields({ Form_Key });

  const [GetDataByID, { loading: getClaimByIdLoading }] = useLazyQuery(getClaimById, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const [EditingData, { loading: editClaimLoading }] = useMutation(edit_Claims, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const [approvedClaim, { loading: approvedClaimLoading }] = useMutation(accecpt_Claim, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const [rejectClaim, { loading: rejectClaimLoading }] = useMutation(reject_Claim, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const ClaimLoadingState = getClaimByIdLoading || editClaimLoading || approvedClaimLoading || rejectClaimLoading;

  useEffect(() => {
    setSelectedRows(fielddataRedux[Form_Key]?.Selected_Rows);
  }, [fielddataRedux]);

  useEffect(() => {
    if (FormData.Damage_Material_Quantity && FormData.Rate) {
      const amountValue = FormData.Damage_Material_Quantity * FormData.Rate;
      updateSingleField(formRef, "Amount", amountValue);
    }
  }, [FormData.Damage_Material_Quantity, FormData.Rate]);

  useEffect(() => {
    if (TypeOfPortal !== "Add" && TypeOfPortal !== "Delete") {
      getFormSectionAndFields().then(() => {
        GetDataByID({
          variables: {
            id: fielddata?._id,
          },
        }).then(({ data }) => {
          console.log(data, "HHHHHHHHH");
          let ClaimData = {
            ...data?.Claim,
          };
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: Form_Key,
              data: {
                TripBookingId: ClaimData?.TripBookingId,
              },
            },
          });
          updateValueForm(formRef, ClaimData);
          setAllFieldsData(ClaimData);
        });
      });
    } else {
      setAllFieldsData({});
    }
  }, [fielddata]);

  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key)
    }
  }, []);

  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);
    if (!Error) {
      submit();
    }
  };

  const HanldeChangeonForm = (values) => {
    setFormdata(prev=>{
      const next = {...prev,...values};
      if(!isFirstLoad){
        setInitialData(next)
      }
      return next
    })
  };


  const { executeOperation } = useSubmitOperation();
  const operationType = TypeOfPortal;
  let formData = FormData;
  const variables = usePrepareGraphQLVariables(operationType, allFieldsData, formData, selectedRows);
  const mutationFunctions = {
    // CreatingData,
    EditingData,
    // DeletingData,
  };

  const submit = async (closeAction) => {
    const mutationFunction = getMutationFunction(operationType, mutationFunctions);
    const executeOperationFunction = () =>
      executeOperation({
        operationType,
        data: formData,
        selectedRows,
        Mutation: () => mutationFunction({ variables }),
        processDataBeforeSubmit: (data) => data,
        EditRefresh: false,
        PageName: Form_Key,
        OnSuccess: (res) => {
          handleFormReset(formRef);
        },
      });
    handleFormSubmission(executeOperationFunction, {
      dispatch,
      operationType,
      closeAction,
      closeFormFunction: Closeformfunction,
      resetFormDataFunction: () => handleFormReset(formRef),
      onSuccess: () => {
        if (operationType === "Edit" || operationType === "Delete") {
          dispatch({ type: "Refetch", payload: true });
        }
      },
      onError: (error) => {
        ErrorToast(error.message);
      },
    });
  };

  const Closeformfunction = useCallback(() => {
    popModal(Form_Key);
    ParentPortalCloseFunction();
    settoggle(false);
    setAllFieldsData({});
    ClearSpecificForm(dispatch, Form_Key);
  }, []);

  const SaveAndCloseForAdd = () => {
    submit("Close");
  };

  const handleClaimApproval = async () => {
    setOpenAcceptModal({ status: true, id: fielddata?._id, message: "Are You Sure You Want to accept this claim?" });
  };

  const handleClaimRejection = async () => {
    setOpenRejectModal({ status: true, id: fielddata?._id, message: "Are You Sure You Want to reject this claim?" });
  };

  const acceptAndRejectSubmitFunction = async () => {
    try {
      try {
        if (openAcceptModal.status) {
          await approvedClaim({ variables: { id: fielddata?._id } });
          SuccessToast("The claim has been successfully approved.");
        } else if (openRejectModal.status) {
          await rejectClaim({ variables: { id: fielddata?._id } });
          SuccessToast("The claim has been successfully rejected.");
        }
      } catch (error) {
        ErrorToast(`Error while ${openAcceptModal.status ? "approving" : "rejecting"} the claim.`);
      }
    } catch (error) {
      ErrorToast("An error occurred while approving the claim. Please try again.");
      console.error("Claim approval error:", error);
    }
  };

  const handleCloseAcceptOrRejectModal = () => {
    if (openAcceptModal.status) {
      setOpenAcceptModal(false);
    } else if (openRejectModal.status) {
      setOpenRejectModal(false);
    }
  };

  if (openAcceptModal.status || openRejectModal.status) {
    return (
      <Reactportal
        open={openAcceptModal.status ? openAcceptModal.status : openRejectModal.status}
        onClose={() => handleCloseAcceptOrRejectModal()}
        TypeOfPortal={"Confirm"}
      >
        <div className="warning">
          <RiErrorWarningFill className="warningIcon" />
          <p className="warningMsg">{openAcceptModal.status ? openAcceptModal.message : openRejectModal.message}</p>
        </div>

        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitform={() => acceptAndRejectSubmitFunction()}
          submitType={"Confirm Change"}
          handleformclose={() => {
            handleCloseAcceptOrRejectModal();
          }}
          loadingState={ClaimLoadingState}
        />
      </Reactportal>
    );
  }

  const footerContent = (
    <PortalFooter
      renderContent={() => (
        <>
          {
            <>
              <Button action={() => handleClaimApproval()} name="modalbutton" text="Approved claim" />
              <Button action={() => handleClaimRejection()} name="modalbutton" text="Reject claim" />
            </>
          }
        </>
      )}
      disabled={isDisabled}
      Form_key={Form_Key}
      submitform={() => {
        Validate_handleSubmit(submit);
      }}
      submitType={submitType}
      SaveAndClose={
        TypeOfPortal === "Add"
          ? () => {
              Validate_handleSubmit(SaveAndCloseForAdd);
            }
          : () => {
              Validate_handleSubmit(submit);
            }
      }
      handleformclose={() => {
        Closeformfunction();
        settoggle(!toggle);
      }}
      loadingState={ClaimLoadingState}
    />
  );

  return (
    <>
      <Reactportal FoooterContent={footerContent} open={toggle} onClose={Closeformfunction} TypeOfPortal={TypeOfPortal}>
        {ClaimLoadingState && <div className="loader-line-div" />}
        <div className="formContainer">
          {inputFields && inputFields?.length > 0 ? (
            inputFields?.map((e) => (
              <div className="FormSectionParent">
                <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                <div className="FormSection insidecontainerForThreeSideBySide">
                  <FormInputSectionComponent
                    inputfields={e.fields}
                    Type={e.name}
                    TypeOfPortal={TypeOfPortal}
                    onErrorsChange={handleErrorsChange}
                    onhandleFormikChange={HanldeChangeonForm}
                    formRef={formRef}
                    formkey={Form_Key}
                    setFirstLoad={setFirstLoad}
                  />
                </div>
              </div>
            ))
          ) : !getFormFieldsLoading && (inputFields?.message || inputFields?.length === 0) ? (
            <p>No form fields available.</p>
          ) : null}
        </div>
      </Reactportal>
    </>
  );
};
export default memo(AddClaimsComponent);
